import { useMemo } from "react";

import { useAgencyNotices } from "../../contexts/agency-notices.context";
import { agencyNoticesHelper } from "../../helpers/agency-notices.helper";
import { AgencyNoticeModel } from "../../models/agency-notice.model";

export const useAgencyNoticesOrchestratorViewModel = () => {
  const {
    agencyNotices,
    isLoadingAgencyNotices,
    seenAgencyNoticeTokens,
  } = useAgencyNotices();

  const dialogAgencyNotices = useMemo(() => {
    if (!agencyNotices) {
      return null;
    }

    const unseenAgencyNotices = agencyNotices.filter(
      (an) => !seenAgencyNoticeTokens.has(an.token),
    );

    return unseenAgencyNotices
      .filter((an) => new AgencyNoticeModel(an).isDialog())
      .sort(
        (a, b) =>
          new AgencyNoticeModel(a).getCreatedAtTimestamp() -
          new AgencyNoticeModel(b).getCreatedAtTimestamp(),
      );
  }, [agencyNotices, seenAgencyNoticeTokens]);

  const headerBannerAgencyNotice = useMemo(() => {
    if (!agencyNotices) {
      return null;
    }

    const unseenAgencyNotices = agencyNotices.filter(
      (an) => !seenAgencyNoticeTokens.has(an.token),
    );

    return agencyNoticesHelper.findBestHeaderBannerAgencyNotice(
      unseenAgencyNotices,
    );
  }, [agencyNotices, seenAgencyNoticeTokens]);

  const shouldShowLoading = useMemo(() => {
    return !agencyNotices && isLoadingAgencyNotices;
  }, [agencyNotices, isLoadingAgencyNotices]);

  return {
    dialogAgencyNotices,
    headerBannerAgencyNotice,
    shouldShowLoading,
  };
};
